/* eslint-disable camelcase, no-bitwise */
import { Component, Vue, Watch } from 'vue-property-decorator';

interface Node {
  p3_bne_name?: string;
  crud: number;
  p4_node_id: number;
  p4_node_name: string;
  p4_node_pid?: number;
  p4_node_route?: string;
}

@Component
export default class crud extends Vue {
  /**
   * 從本地儲存的menu列表取出相應權限
   */
  get $crud(): number {
    const localNodes: string | null = localStorage.getItem('Node');
    if (localNodes) {
      const userNodes: Node[] = JSON.parse(localNodes);
      const [currentNode]: any = userNodes.filter(
        (node: Node): boolean => node.p4_node_route === this.$route.meta.url,
      );
      if (typeof currentNode === 'object') {
        return currentNode.crud;
      }
    }
    return 0;
  }

  public $getCrud(path: string): number {
    const self = this;
    const localNodes: string | null = localStorage.getItem('Node');
    if (localNodes) {
      const userNodes: Node[] = JSON.parse(localNodes);
      const [currentNode]: any = userNodes.filter(
        (node: Node): boolean => node.p4_node_route === path,
      );
      if (typeof currentNode === 'object') {
        return currentNode.crud;
      }
    }
    return 0;
  }
}
